import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import {
  Column,
  communicationsColumns,
  CommunicationsDocument,
  documentsAreaMessages,
  labelForCommunicationsDocumentsType,
  DocumentsAreaSections
} from 'azshared';
import React, { Fragment, MouseEvent, useCallback } from 'react';
import { useIntl } from 'react-intl';
import { AppButtonIcon } from '../../../../../components/button-icon/app-button-icon';
import { AppPill } from '../../../../../components/pill/pill';
import { AppTableCell } from '../../../../../components/table/table-cell';
import { AppTableCellHeader } from '../../../../../components/table/table-cell-header';
import './communications-table.scss';

export interface CommunicationsTableProps {
  documents: CommunicationsDocument[];
  onReadDocument: (document: CommunicationsDocument, documentsAreaSection: DocumentsAreaSections) => void;
  onDownloadDocument: (document: CommunicationsDocument, documentsAreaSection: DocumentsAreaSections) => void;
}

export const CommunicationsTable = (props: CommunicationsTableProps) => {
  const { formatMessage } = useIntl();
  const { documents, onDownloadDocument } = props;
  const columns: Column<CommunicationsDocument>[] = communicationsColumns;

  const handleDownload = useCallback(
    (_: MouseEvent<HTMLOrSVGElement> | React.KeyboardEvent<HTMLOrSVGElement>, id?: string) => {
      const document = documents.find((doc) => doc.id === id);
      if (document?.id) {
        onDownloadDocument(document, 'COMMUNICATIONS');
      }
    },
    [documents, onDownloadDocument]
  );

  return (
    <TableContainer className='communications-table'>
      <Table aria-label='table'>
        <TableHead>
          <TableRow>
            {columns.map((column, index) => (
              <AppTableCellHeader key={index} className='communications-table-header'>
                {column.headerLabel && formatMessage(column.headerLabel)}
              </AppTableCellHeader>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {documents?.map((document: any, index) => (
            <TableRow key={index} className={`communications-table-row ${!document.flagIsRead ? 'communications-table-row-bold' : ''}`}>
              {columns.map((col) => (
                <Fragment key={col.key}>
                  {col.key === 'title' && (
                    <AppTableCell key={col.key} align='left' type={col.type}>
                      <div className='communications-table-row-title'>
                        <AppButtonIcon icon='download-document' onClick={handleDownload} id={document.id} />
                        <span>{document[col.key]}</span>
                      </div>
                    </AppTableCell>
                  )}
                  {col.key === 'flagIsRead' && (
                    <AppTableCell key={col.key} align='left' type={col.type}>
                      {!document.flagIsRead && <AppPill color='success' label={formatMessage(documentsAreaMessages.notReadBadge)}></AppPill>}
                    </AppTableCell>
                  )}
                  {col.key === 'code' && (
                    <AppTableCell key={col.key} align='left' type={col.type}>
                      {formatMessage(labelForCommunicationsDocumentsType(document[col.key]))}
                    </AppTableCell>
                  )}
                  {col.key !== 'title' && col.key !== 'flagIsRead' && col.key !== 'code' && (
                    <AppTableCell key={col.key} align='left' type={col.type}>
                      {document[col.key]}
                    </AppTableCell>
                  )}
                </Fragment>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
